"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("react");
const react_slider_1 = __importDefault(require("react-slider"));
const toRangeTuple = (val, fallback) => {
    if (Array.isArray(val) && val.length >= 2) {
        return [val[0], val[1]];
    }
    if (typeof val === "number") {
        return [val, fallback[1]];
    }
    return fallback;
};
const toRangeData = (data) => {
    if (Array.isArray(data) && data.length >= 2) {
        const first = Number(data[0]);
        const second = Number(data[1]);
        return [Number.isNaN(first) ? 0 : first, Number.isNaN(second) ? 0 : second];
    }
    return [0, 0];
};
const FilterRange = (props) => {
    const dataRange = toRangeData(props.filter.data);
    const [value, setValue] = (0, react_1.useState)([
        Array.isArray(props.filter.value) ? Number(props.filter.value[0]) : dataRange[0],
        Array.isArray(props.filter.value) ? Number(props.filter.value[1]) : dataRange[1],
    ]);
    const [active, setActive] = (0, react_1.useState)(Boolean(props.filter.active));
    const changeActive = (newStatus) => {
        setActive(newStatus);
        props.changeActive(newStatus);
    };
    const resetFilter = () => {
        if (active) {
            const newVal = dataRange;
            setValue(newVal);
            changeActive(false);
            props.filter.value = value;
            props.changeFilter("range", Object.assign(Object.assign({}, props.filter), { value: newVal }));
        }
    };
    const handleResetClick = (ev) => {
        ev.preventDefault();
        resetFilter();
    };
    (0, react_2.useEffect)(() => {
        if (!props.filter.active && active) {
            resetFilter();
        }
    }, [props.filter.active]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "m-filter-range", children: [(0, jsx_runtime_1.jsx)(react_slider_1.default, { className: "horizontal-slider", thumbClassName: "dot", trackClassName: "track", min: dataRange[0], max: dataRange[1], defaultValue: [value[0], value[1]], value: [value[0], value[1]], ariaLabel: ["Lower thumb", "Upper thumb"], ariaValuetext: (state) => `Thumb value ${state.valueNow}`, renderThumb: (thumbProps, state) => ((0, jsx_runtime_1.jsx)("div", Object.assign({}, thumbProps, { children: state.valueNow }))), pearling: true, minDistance: 1, onChange: (val) => {
                            setValue(toRangeTuple(val, value));
                        }, onAfterChange: (val) => {
                            const tuple = toRangeTuple(val, value);
                            setValue(tuple);
                            changeActive(true);
                            props.filter.value = tuple;
                            props.changeFilter("range", props.filter);
                        } }), (0, jsx_runtime_1.jsxs)("div", { className: "ranges", children: [(0, jsx_runtime_1.jsxs)("div", { className: "range-input", children: ["Fra", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("input", { type: "text", value: value[0], onChange: (e) => setValue([Number(e.target.value), value[1]]), onKeyUp: (e) => {
                                            e.preventDefault();
                                            if (e.key === "Enter") {
                                                changeActive(true);
                                                props.filter.value = value;
                                                props.changeFilter("range", props.filter);
                                            }
                                        } })] }), (0, jsx_runtime_1.jsxs)("div", { className: "range-input", children: ["Til", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("input", { type: "text", value: value[1], onChange: (e) => setValue([value[0], Number(e.target.value)]), onKeyUp: (e) => {
                                            e.preventDefault();
                                            if (e.key === "Enter") {
                                                changeActive(true);
                                                props.filter.value = value;
                                                props.changeFilter("range", props.filter);
                                            }
                                        } })] })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "buttons", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (ev) => {
                                handleResetClick(ev);
                            }, children: "Nullstill" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: "#", onClick: (ev) => {
                                ev.preventDefault();
                                props.changeFilter("expand", Object.assign(Object.assign({}, props.filter), { expanded: !props.filter.expanded }));
                            }, children: "Lukk" }) })] })] }));
};
exports.default = FilterRange;
